module.exports = __webpack_public_path__ + "img/9788934905714.eeb53e84.jpg";